import { LogOut, MessageSquare, ScanText } from 'lucide-react'
import { useShell } from '@/shared/context/ShellContext'
import { SegmentedSwitch } from './SegmentedSwitch'

type View = 'chat' | 'scan'

/** Top-right overlay: doc-sync status (chat view only) + scan toggle + sign-out. */
export function PaneTopBar() {
  const { showScan, canScan, toggleView, signOut } = useShell()
  return (
    <div className='ramp-topbar'>
      {/* {!showScan && <SyncStatus />} */}
      {canScan && (
        <div className='ramp-topbar-center'>
          <SegmentedSwitch<View>
            value={showScan ? 'scan' : 'chat'}
            onChange={toggleView}
            options={[
              { value: 'chat', label: 'Chat', icon: <MessageSquare size={16} /> },
              { value: 'scan', label: 'Scan', icon: <ScanText size={16} /> }
            ]}
          />
        </div>
      )}
      <div className='ramp-pane-actions'>
        <button type='button' className='ramp-action' onClick={signOut}>
          <LogOut size={16} />
          <span className='ramp-action-label'>Sign out</span>
        </button>
      </div>
    </div>
  )
}
